import Command from '@ckeditor/ckeditor5-core/src/command';
import { Writer } from '@ckeditor/ckeditor5-core/src/editor';
import { addEmptyParagraphAfterPlugin } from '../utils';
import { InsertTaskCommandOptions } from './types';

export class InsertTaskSectionCommand extends Command {
  execute({ resourceSectionId: value }: InsertTaskCommandOptions) {
    const { editor } = this;

    const { dataset } = editor.sourceElement;

    editor.model.change((writer: Writer) => {
      const taskSection = writer.createElement('taskSection', {
        taskSection: value,
        isPrivate: dataset.isprivate === 'true',
        editorSectionId: dataset.sectionid,
      });

      editor.model.insertContent(taskSection);

      addEmptyParagraphAfterPlugin(editor, writer, taskSection);

      editor.editing.view.focus();
    });
  }

  refresh() {
    const { model } = this.editor;
    const { selection } = model.document;

    const isAllowed = model.schema.findAllowedParent(
      selection.getFirstPosition(),
      'taskSection',
    );

    this.isEnabled = isAllowed !== null;
  }
}
